import { Static, Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../../routes/createPathParameter';
import { createdResponse, removedResponse } from '../../../routes/defaultResponses';
import { makeNullable } from '../../../utils/typeboxHelpers';
import { utProjectTableSchema } from './utProjectTableSchema';

const getUtProjectsSearchParametersSchema = Type.Object({
    name: Type.Optional(Type.String()),
});

export type GetUtProjectsSearchParametersSchema = Static<typeof getUtProjectsSearchParametersSchema>;

export const utProjectPaths = {
    // '/api/utprojects/download/excel': {
    //     get: {
    //         operationId: 'utProjectControllers.downloadExcel',
    //         responses: {
    //             '200': {
    //                 description: 'Excel file download',
    //                 content: {
    //                     'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
    //                         schema: Type.String({ format: 'binary' }),
    //                     },
    //                 },
    //             },
    //         },
    //         parameters: [
    //             {
    //                 name: 'languageCode',
    //                 in: 'query',
    //                 required: true,
    //                 schema: Type.String(),
    //             },
    //         ],
    //     },
    // },
    '/api/utprojects': {
        get: {
            operationId: 'utProjectControllers.getAllUtProjects',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                items: Type.Array(
                                    Type.Intersect([
                                        Type.Pick(utProjectTableSchema, [
                                            'id',
                                            'name',
                                            'deviceName',
                                            'pilotName',
                                            'surveyorName',
                                            'description',
                                            'createdOnDateTime',
                                            'clientName',
                                            'surveyId',
                                        ]),
                                        Type.Object({
                                            objects: Type.Object({ name: makeNullable(Type.String()) }),
                                        }),
                                        Type.Object({
                                            surveys: Type.Object({
                                                description: makeNullable(Type.String()),
                                                surveyedOn: makeNullable(Type.String()),
                                            }),
                                        }),
                                    ]),
                                ),
                            }),
                        },
                    },
                },
            },
            parameters: [
                {
                    name: 'searchParameters',
                    in: 'query',
                    schema: getUtProjectsSearchParametersSchema,
                },
            ],
        },
    },
    '/api/utprojects/{projectId}': {
        parameters: [createPathGuidParameter('projectId')],
        delete: {
            operationId: 'utProjectControllers.delete',
            responses: {
                ...removedResponse,
            },
        },
    },
    '/api/utprojects/{projectId}/copy': {
        parameters: [createPathGuidParameter('projectId')],
        post: {
            operationId: 'utProjectControllers.copy',
            responses: {
                ...createdResponse,
            },
        },
    },
    '/api/surveys/{surveyId}/projects': {
        parameters: [createPathGuidParameter('surveyId')],
        get: {
            operationId: 'utProjectControllers.getProjectsInSurvey',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(Type.Pick(utProjectTableSchema, ['id', 'name', 'deviceName', 'pilotName', 'surveyorName'])),
                        },
                    },
                },
            },
        },
    },
} as const;
